export default __webpack_public_path__ + "static/media/item_service_custom_software_development_0.6f352429.png";